import { setGuarantorCredit } from './setGuarantorCredit';

export const guarantor = {
  setGuarantorCredit,
};
